const viewAny = (permissions) => {
  return permissions.includes('read-users')
}

const create = (permissions) => {
  return hasPermission(permissions, 'create-users')
}

const update = (permissions, user) => {
  return hasPermission(permissions, 'update-users')
}

const deletee = (permissions, current_user, user) => {
  return hasPermission(permissions, 'delete-users') && current_user.id != user.id
}

const manageUsers = (permissions) => {
  return hasPermissions(permissions, [
    'create-users',
    'read-users',
    'update-users',
    'delete-users'
  ])
}

const manageItems = (permissions) => {
  return hasPermissions(permissions, [
    'create-users',
    'read-users',
    'update-users',
    'delete-users'
  ])
}

const manageSettings = (permissions) => {
  return hasPermissions(permissions, [
    'create-users',
    'read-users',
    'update-users',
    'delete-users'
  ])
}

const hasPermission = (permissions, permission) => {
  return permissions.includes(permission)
}

const hasPermissions = (permissions, _permissions) => {
  return _permissions.some(permission => {
    return permissions.includes(permission)
  })
}

export {
  viewAny,
  create,
  update,
  deletee,
  manageUsers,
  manageItems,
  manageSettings,
  hasPermission,
};